<template>
  <ValidationObserver ref="observer"
        tag="form"
        class="mx-2">
        <div>
            <div class="row d-flex align-items-center mt-5">
                <div class="col-sm-6">
                    <h4>Nodarbināto saraksts atbilstoši periodiskumam</h4>
                </div>
                <div class="col-sm-6 d-flex justify-content-end">
                    <UserOvpJobConditionsGenerate/>
                    <UserOvpJobConditionsExport/>
                </div>
            </div>
            <UserOvpJobConditionListTable :hasSearch="true"/>
        </div>
    </ValidationObserver>
</template>
<script>
    import {ValidationObserver} from 'vee-validate';
    import UserOvpJobConditionsGenerate from './UserOvpJobConditionsGenerate';
    import UserOvpJobConditionListTable from './UserOvpJobConditionListTable';   
    import UserOvpJobConditionsExport from './UserOvpJobConditionsExport.vue';

    export default {
        name: 'users-ovp-job-conditions',
        components: {
             UserOvpJobConditionListTable, UserOvpJobConditionsGenerate, UserOvpJobConditionsExport, ValidationObserver},
        data: () => ({}),
    }
</script>